import { User } from 'graphql/types/User';

export const sortAlphabeticallyUsersByName = (val: User[]) => {
  return [...val].sort((a, b) => {
    const nameA = a.name.toLowerCase();
    const nameB = b.name.toLowerCase();
    return nameA > nameB ? 1 : nameB > nameA ? -1 : 0;
  });
};
